import { apply, put, select } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import { onLoadChecklistItemAnswersSucceeded } from '../reducers/checklistItem.reducers';

import {
  errorNotification,
  successNotification,
} from '../reducers/notification.reducers';

//load checklist item answers
export function* loadChecklistItemAnswers(checklistApi) {
  try {
    const checklistRunId = yield select(
      (state) => state.checklist.selectedChecklistRun.id
    );
    const response = yield apply(
      checklistApi,
      checklistApi.loadChecklistItemAnswers,
      [checklistRunId]
    );
    if (response.errorCode) {
      yield put(errorNotification('Fehler beim Laden der Task Answers'));
    } else {
      yield put(
        onLoadChecklistItemAnswersSucceeded({ checklistItemAnswers: response })
      );
    }
  } catch (e) {
    console.log(e);
  }
}

export function* sendChecklistRunAction(checklistApi, { payload }) {
  try {
    const checklistRunDto = {
      startDate: yield select(
        (state) => state.checklists.checklistRunStartedAt
      ),
      cardId: payload.card.id,
      action: payload.type,
    };

    yield apply(checklistApi, checklistApi.sendRunAction, [checklistRunDto]);
  } catch (e) {
    console.log(e);
  }
}

export function* submitChecklistItemAnswers(checklistApi) {
  try {
    const checklistItemAnswers = yield select(
      (state) => state.checklistItem.checklistItemAnswers
    );
    const runId = yield select(
      (state) => state.checklist.selectedChecklistRun.id);
    const answers = {
      ChecklistRunAnswers: checklistItemAnswers,
    };
    yield apply(checklistApi, checklistApi.submitChecklistRunAnswers, [
      runId,
      answers,
    ]);
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/app/sagas/checklistItem.sagas.js